export const OSCARS_2026_LOCK_AT = '2026-03-15T19:00:00-04:00';

export const OSCARS_2026_USERS = [
  { slug: 'matteo', name: 'Matteo' },
  { slug: 'kitti', name: 'Kitti' },
];

const TRAILER_URLS = {
  'Marty Supreme': 'https://www.youtube.com/watch?v=s9gSuKaKcqM',
  'One Battle after Another': 'https://www.youtube.com/watch?v=feOQFKv2Lw4',
  'Blue Moon': 'https://www.youtube.com/watch?v=qo7gRHip0lI',
  'Sinners': 'https://www.youtube.com/watch?v=bKGxHflevuk',
  'The Secret Agent': 'https://www.youtube.com/watch?v=9UfrzDKrhEc',
  'Frankenstein': 'https://www.youtube.com/watch?v=8aulMPhE12g',
  'Sentimental Value': 'https://www.youtube.com/watch?v=lKbcKQN5Yrw',
  'Hamnet': 'https://www.youtube.com/watch?v=xYcgQMxQwmk',
  "If I Had Legs I'd Kick You": 'https://www.youtube.com/watch?v=ywFDoT7LBbQ',
  'Song Sung Blue': 'https://www.youtube.com/watch?v=ZqU7iiHFCzw',
  'Bugonia': 'https://www.youtube.com/watch?v=bd_5HcTujfc',
  'Weapons': 'https://www.youtube.com/watch?v=OpThntO9ixc',
  'Arco': 'https://www.youtube.com/watch?v=e4RrOe8IbI8',
  'Elio': 'https://www.youtube.com/watch?v=ETVi5_cnnaE',
  'KPop Demon Hunters': 'https://www.youtube.com/watch?v=3JTVQTk36R8',
  'Little Amelie or the Character of Rain': 'https://www.youtube.com/watch?v=R4UzR12bBBE',
  'Little Amélie or the Character of Rain': 'https://www.youtube.com/watch?v=R4UzR12bBBE',
  'Zootopia 2': 'https://www.youtube.com/watch?v=BjkIOU5PhyQ',
  'Butterfly': 'https://www.youtube.com/watch?v=LxzgHBFcZc4',
  'Forevergreen': 'https://www.youtube.com/watch?v=87G4HrFll-o',
  'The Girl Who Cried Pearls': 'https://www.youtube.com/watch?v=c_amkqzonSM',
  'Retirement Plan': 'https://www.youtube.com/watch?v=-FgrU4GORts',
  'The Three Sisters': 'https://www.youtube.com/watch?v=h5szJvASbrw',
  'The Alabama Solution': 'https://www.youtube.com/watch?v=xRNND_uve8I',
  'Come See Me in the Good Light': 'https://www.youtube.com/watch?v=t0B8sjxR7Mo',
  'Cutting through Rocks': 'https://www.youtube.com/watch?v=cLcPT_MpwVM',
  'Mr. Nobody against Putin': 'https://www.youtube.com/watch?v=dcUeDa8FK_8',
  'The Perfect Neighbor': 'https://www.youtube.com/watch?v=fNp85HGJtoo',
  'All the Empty Rooms': 'https://www.youtube.com/watch?v=JhpJ8INsR0g',
  'Armed Only with a Camera: The Life and Death of Brent Renaud': 'https://www.youtube.com/watch?v=bceerB407LY',
  'Children No More: "Were and Are Gone"': 'https://www.youtube.com/watch?v=VE75N-uTN58',
  'The Devil Is Busy': 'https://www.youtube.com/watch?v=p4rC1468JuQ',
  'Perfectly a Strangeness': 'https://www.youtube.com/watch?v=vG8rOAi6Q2g',
  'F1': 'https://www.youtube.com/watch?v=69ffwl-8pCU',
  'It Was Just an Accident': 'https://www.youtube.com/watch?v=nF04v-ze2Yc',
  'Sirat': 'https://www.youtube.com/watch?v=MB6SL4gsldc',
  'Sirāt': 'https://www.youtube.com/watch?v=MB6SL4gsldc',
  'The Voice of Hind Rajab': 'https://www.youtube.com/watch?v=hrssPpqv6vc',
  "Butcher's Stain": 'https://www.youtube.com/watch?v=Z0AehemQwF4',
  'A Friend of Dorothy': 'https://www.youtube.com/watch?v=v_hafSoyz_8',
  "Jane Austen's Period Drama": 'https://www.youtube.com/watch?v=jltKNiq-eK0',
  'The Singers': 'https://www.youtube.com/watch?v=GchFxN1G1tw',
  'Two People Exchanging Saliva': 'https://www.youtube.com/watch?v=6klvwgo4DUE',
  'Kokuho': 'https://www.youtube.com/watch?v=Y0KfXj3Skao',
  'The Smashing Machine': 'https://www.youtube.com/watch?v=aRpnP3LZ99g',
  'The Ugly Stepsister': 'https://www.youtube.com/watch?v=52C0rqyZKhg',
  'Diane Warren: Relentless': 'https://www.youtube.com/watch?v=X1sacIFNhIk',
  'Viva Verdi!': 'https://www.youtube.com/watch?v=DRsWyAiQ_dY',
  'Train Dreams': 'https://www.youtube.com/watch?v=_Nk8TrBHOrA',
  'Avatar: Fire and Ash': 'https://www.youtube.com/watch?v=nb_fFj_0rq8',
  'Jurassic World Rebirth': 'https://www.youtube.com/watch?v=jan5CFWs9ic',
  'The Lost Bus': 'https://www.youtube.com/watch?v=XSDHjkuwaic',
};

const trailer = (title) => TRAILER_URLS[title] || null;

export const OSCARS_2026_CATEGORIES = [
{
    slug: 'best-picture',
    name: 'Best Picture',
    nominees: [
      { slug: 'bugonia', label: 'Bugonia', filmTitle: 'Bugonia', trailerUrl: trailer('Bugonia') },
      { slug: 'f1', label: 'F1', filmTitle: 'F1', trailerUrl: trailer('F1') },
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'hamnet', label: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'marty-supreme', label: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'the-secret-agent', label: 'The Secret Agent', filmTitle: 'The Secret Agent', trailerUrl: trailer('The Secret Agent') },
      { slug: 'sentimental-value', label: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'train-dreams', label: 'Train Dreams', filmTitle: 'Train Dreams', trailerUrl: trailer('Train Dreams') },
    ],
  },
{
    slug: 'directing',
    name: 'Directing',
    nominees: [
      { slug: 'chloe-zhao', label: 'Chloe Zhao', sublabel: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'josh-safdie', label: 'Josh Safdie', sublabel: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'paul-thomas-anderson', label: 'Paul Thomas Anderson', sublabel: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'joachim-trier', label: 'Joachim Trier', sublabel: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'ryan-coogler', label: 'Ryan Coogler', sublabel: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'actor-leading-role',
    name: 'Actor in a Leading Role',
    nominees: [
      { slug: 'timothee-chalamet', label: 'Timothee Chalamet', sublabel: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'leonardo-dicaprio', label: 'Leonardo DiCaprio', sublabel: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'ethan-hawke', label: 'Ethan Hawke', sublabel: 'Blue Moon', filmTitle: 'Blue Moon', trailerUrl: trailer('Blue Moon') },
      { slug: 'michael-b-jordan', label: 'Michael B. Jordan', sublabel: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'wagner-moura', label: 'Wagner Moura', sublabel: 'The Secret Agent', filmTitle: 'The Secret Agent', trailerUrl: trailer('The Secret Agent') },
    ],
  },
{
    slug: 'actress-leading-role',
    name: 'Actress in a Leading Role',
    nominees: [
      { slug: 'jessie-buckley', label: 'Jessie Buckley', sublabel: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'rose-byrne', label: 'Rose Byrne', sublabel: "If I Had Legs I'd Kick You", filmTitle: "If I Had Legs I'd Kick You", trailerUrl: trailer("If I Had Legs I'd Kick You") },
      { slug: 'kate-hudson', label: 'Kate Hudson', sublabel: 'Song Sung Blue', filmTitle: 'Song Sung Blue', trailerUrl: trailer('Song Sung Blue') },
      { slug: 'renate-reinsve', label: 'Renate Reinsve', sublabel: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'emma-stone', label: 'Emma Stone', sublabel: 'Bugonia', filmTitle: 'Bugonia', trailerUrl: trailer('Bugonia') },
    ],
  },
{
    slug: 'actor-supporting-role',
    name: 'Actor in a Supporting Role',
    nominees: [
      { slug: 'benicio-del-toro', label: 'Benicio Del Toro', sublabel: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'jacob-elordi', label: 'Jacob Elordi', sublabel: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'delroy-lindo', label: 'Delroy Lindo', sublabel: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'sean-penn', label: 'Sean Penn', sublabel: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'stellan-skarsgard', label: 'Stellan Skarsgard', sublabel: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
    ],
  },
{
    slug: 'actress-supporting-role',
    name: 'Actress in a Supporting Role',
    nominees: [
      { slug: 'elle-fanning', label: 'Elle Fanning', sublabel: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'inga-ibsdotter-lilleaas', label: 'Inga Ibsdotter Lilleaas', sublabel: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'amy-madigan', label: 'Amy Madigan', sublabel: 'Weapons', filmTitle: 'Weapons', trailerUrl: trailer('Weapons') },
      { slug: 'wunmi-mosaku', label: 'Wunmi Mosaku', sublabel: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'teyana-taylor', label: 'Teyana Taylor', sublabel: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
    ],
  },
{
    slug: 'writing-original-screenplay',
    name: 'Writing (Original Screenplay)',
    nominees: [
      { slug: 'blue-moon', label: 'Blue Moon', filmTitle: 'Blue Moon', trailerUrl: trailer('Blue Moon') },
      { slug: 'it-was-just-an-accident', label: 'It Was Just an Accident', filmTitle: 'It Was Just an Accident', trailerUrl: trailer('It Was Just an Accident') },
      { slug: 'marty-supreme', label: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'sentimental-value', label: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'writing-adapted-screenplay',
    name: 'Writing (Adapted Screenplay)',
    nominees: [
      { slug: 'bugonia', label: 'Bugonia', filmTitle: 'Bugonia', trailerUrl: trailer('Bugonia') },
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'hamnet', label: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'train-dreams', label: 'Train Dreams', filmTitle: 'Train Dreams', trailerUrl: trailer('Train Dreams') },
    ],
  },
{
    slug: 'animated-feature-film',
    name: 'Animated Feature Film',
    nominees: [
      { slug: 'arco', label: 'Arco', filmTitle: 'Arco', trailerUrl: trailer('Arco') },
      { slug: 'elio', label: 'Elio', filmTitle: 'Elio', trailerUrl: trailer('Elio') },
      { slug: 'kpop-demon-hunters', label: 'KPop Demon Hunters', filmTitle: 'KPop Demon Hunters', trailerUrl: trailer('KPop Demon Hunters') },
      { slug: 'little-amelie', label: 'Little Amelie or the Character of Rain', filmTitle: 'Little Amelie or the Character of Rain', trailerUrl: trailer('Little Amelie or the Character of Rain') },
      { slug: 'zootopia-2', label: 'Zootopia 2', filmTitle: 'Zootopia 2', trailerUrl: trailer('Zootopia 2') },
    ],
  },
{
    slug: 'international-feature-film',
    name: 'International Feature Film',
    nominees: [
      { slug: 'the-secret-agent', label: 'The Secret Agent', sublabel: 'Brazil', filmTitle: 'The Secret Agent', trailerUrl: trailer('The Secret Agent') },
      { slug: 'it-was-just-an-accident', label: 'It Was Just an Accident', sublabel: 'France', filmTitle: 'It Was Just an Accident', trailerUrl: trailer('It Was Just an Accident') },
      { slug: 'sentimental-value', label: 'Sentimental Value', sublabel: 'Norway', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'sirat', label: 'Sirat', sublabel: 'Spain', filmTitle: 'Sirat', trailerUrl: trailer('Sirat') },
      { slug: 'the-voice-of-hind-rajab', label: 'The Voice of Hind Rajab', sublabel: 'Tunisia', filmTitle: 'The Voice of Hind Rajab', trailerUrl: trailer('The Voice of Hind Rajab') },
    ],
  },
{
    slug: 'documentary-feature-film',
    name: 'Documentary Feature Film',
    nominees: [
      { slug: 'the-alabama-solution', label: 'The Alabama Solution', filmTitle: 'The Alabama Solution', trailerUrl: trailer('The Alabama Solution') },
      { slug: 'come-see-me-in-the-good-light', label: 'Come See Me in the Good Light', filmTitle: 'Come See Me in the Good Light', trailerUrl: trailer('Come See Me in the Good Light') },
      { slug: 'cutting-through-rocks', label: 'Cutting through Rocks', filmTitle: 'Cutting through Rocks', trailerUrl: trailer('Cutting through Rocks') },
      { slug: 'mr-nobody-against-putin', label: 'Mr. Nobody against Putin', filmTitle: 'Mr. Nobody against Putin', trailerUrl: trailer('Mr. Nobody against Putin') },
      { slug: 'the-perfect-neighbor', label: 'The Perfect Neighbor', filmTitle: 'The Perfect Neighbor', trailerUrl: trailer('The Perfect Neighbor') },
    ],
  },
{
    slug: 'music-original-score',
    name: 'Music (Original Score)',
    nominees: [
      { slug: 'bugonia', label: 'Bugonia', filmTitle: 'Bugonia', trailerUrl: trailer('Bugonia') },
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'hamnet', label: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'music-original-song',
    name: 'Music (Original Song)',
    nominees: [
      { slug: 'dear-me', label: 'Dear Me', sublabel: 'Diane Warren: Relentless', filmTitle: 'Diane Warren: Relentless', trailerUrl: trailer('Diane Warren: Relentless') },
      { slug: 'golden', label: 'Golden', sublabel: 'KPop Demon Hunters', filmTitle: 'KPop Demon Hunters', trailerUrl: trailer('KPop Demon Hunters') },
      { slug: 'i-lied-to-you', label: 'I Lied To You', sublabel: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'sweet-dreams-of-joy', label: 'Sweet Dreams Of Joy', sublabel: 'Viva Verdi!', filmTitle: 'Viva Verdi!', trailerUrl: trailer('Viva Verdi!') },
      { slug: 'train-dreams-song', label: 'Train Dreams', sublabel: 'Train Dreams', filmTitle: 'Train Dreams', trailerUrl: trailer('Train Dreams') },
    ],
  },
{
    slug: 'cinematography',
    name: 'Cinematography',
    nominees: [
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'marty-supreme', label: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'train-dreams', label: 'Train Dreams', filmTitle: 'Train Dreams', trailerUrl: trailer('Train Dreams') },
    ],
  },
{
    slug: 'film-editing',
    name: 'Film Editing',
    nominees: [
      { slug: 'f1', label: 'F1', filmTitle: 'F1', trailerUrl: trailer('F1') },
      { slug: 'marty-supreme', label: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'sentimental-value', label: 'Sentimental Value', filmTitle: 'Sentimental Value', trailerUrl: trailer('Sentimental Value') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'production-design',
    name: 'Production Design',
    nominees: [
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'hamnet', label: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'marty-supreme', label: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'costume-design',
    name: 'Costume Design',
    nominees: [
      { slug: 'avatar-fire-and-ash', label: 'Avatar: Fire and Ash', filmTitle: 'Avatar: Fire and Ash', trailerUrl: trailer('Avatar: Fire and Ash') },
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'hamnet', label: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'marty-supreme', label: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'makeup-and-hairstyling',
    name: 'Makeup and Hairstyling',
    nominees: [
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'kokuho', label: 'Kokuho', filmTitle: 'Kokuho', trailerUrl: trailer('Kokuho') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'the-smashing-machine', label: 'The Smashing Machine', filmTitle: 'The Smashing Machine', trailerUrl: trailer('The Smashing Machine') },
      { slug: 'the-ugly-stepsister', label: 'The Ugly Stepsister', filmTitle: 'The Ugly Stepsister', trailerUrl: trailer('The Ugly Stepsister') },
    ],
  },
{
    slug: 'sound',
    name: 'Sound',
    nominees: [
      { slug: 'f1', label: 'F1', filmTitle: 'F1', trailerUrl: trailer('F1') },
      { slug: 'frankenstein', label: 'Frankenstein', filmTitle: 'Frankenstein', trailerUrl: trailer('Frankenstein') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
      { slug: 'sirat', label: 'Sirat', filmTitle: 'Sirat', trailerUrl: trailer('Sirat') },
    ],
  },
{
    slug: 'visual-effects',
    name: 'Visual Effects',
    nominees: [
      { slug: 'avatar-fire-and-ash', label: 'Avatar: Fire and Ash', filmTitle: 'Avatar: Fire and Ash', trailerUrl: trailer('Avatar: Fire and Ash') },
      { slug: 'f1', label: 'F1', filmTitle: 'F1', trailerUrl: trailer('F1') },
      { slug: 'jurassic-world-rebirth', label: 'Jurassic World Rebirth', filmTitle: 'Jurassic World Rebirth', trailerUrl: trailer('Jurassic World Rebirth') },
      { slug: 'the-lost-bus', label: 'The Lost Bus', filmTitle: 'The Lost Bus', trailerUrl: trailer('The Lost Bus') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'casting',
    name: 'Casting',
    nominees: [
      { slug: 'hamnet', label: 'Hamnet', filmTitle: 'Hamnet', trailerUrl: trailer('Hamnet') },
      { slug: 'marty-supreme', label: 'Marty Supreme', filmTitle: 'Marty Supreme', trailerUrl: trailer('Marty Supreme') },
      { slug: 'one-battle-after-another', label: 'One Battle after Another', filmTitle: 'One Battle after Another', trailerUrl: trailer('One Battle after Another') },
      { slug: 'the-secret-agent', label: 'The Secret Agent', filmTitle: 'The Secret Agent', trailerUrl: trailer('The Secret Agent') },
      { slug: 'sinners', label: 'Sinners', filmTitle: 'Sinners', trailerUrl: trailer('Sinners') },
    ],
  },
{
    slug: 'animated-short-film',
    name: 'Animated Short Film',
    nominees: [
      { slug: 'butterfly', label: 'Butterfly', filmTitle: 'Butterfly', trailerUrl: trailer('Butterfly') },
      { slug: 'forevergreen', label: 'Forevergreen', filmTitle: 'Forevergreen', trailerUrl: trailer('Forevergreen') },
      { slug: 'the-girl-who-cried-pearls', label: 'The Girl Who Cried Pearls', filmTitle: 'The Girl Who Cried Pearls', trailerUrl: trailer('The Girl Who Cried Pearls') },
      { slug: 'retirement-plan', label: 'Retirement Plan', filmTitle: 'Retirement Plan', trailerUrl: trailer('Retirement Plan') },
      { slug: 'the-three-sisters', label: 'The Three Sisters', filmTitle: 'The Three Sisters', trailerUrl: trailer('The Three Sisters') },
    ],
  },
{
    slug: 'documentary-short-film',
    name: 'Documentary Short Film',
    nominees: [
      { slug: 'all-the-empty-rooms', label: 'All the Empty Rooms', filmTitle: 'All the Empty Rooms', trailerUrl: trailer('All the Empty Rooms') },
      { slug: 'armed-only-with-a-camera', label: 'Armed Only with a Camera: The Life and Death of Brent Renaud', filmTitle: 'Armed Only with a Camera: The Life and Death of Brent Renaud', trailerUrl: trailer('Armed Only with a Camera: The Life and Death of Brent Renaud') },
      { slug: 'children-no-more', label: 'Children No More: "Were and Are Gone"', filmTitle: 'Children No More: "Were and Are Gone"', trailerUrl: trailer('Children No More: "Were and Are Gone"') },
      { slug: 'the-devil-is-busy', label: 'The Devil Is Busy', filmTitle: 'The Devil Is Busy', trailerUrl: trailer('The Devil Is Busy') },
      { slug: 'perfectly-a-strangeness', label: 'Perfectly a Strangeness', filmTitle: 'Perfectly a Strangeness', trailerUrl: trailer('Perfectly a Strangeness') },
    ],
  },
{
    slug: 'live-action-short-film',
    name: 'Live Action Short Film',
    nominees: [
      { slug: 'butchers-stain', label: "Butcher's Stain", filmTitle: "Butcher's Stain", trailerUrl: trailer("Butcher's Stain") },
      { slug: 'a-friend-of-dorothy', label: 'A Friend of Dorothy', filmTitle: 'A Friend of Dorothy', trailerUrl: trailer('A Friend of Dorothy') },
      { slug: 'jane-austens-period-drama', label: "Jane Austen's Period Drama", filmTitle: "Jane Austen's Period Drama", trailerUrl: trailer("Jane Austen's Period Drama") },
      { slug: 'the-singers', label: 'The Singers', filmTitle: 'The Singers', trailerUrl: trailer('The Singers') },
      { slug: 'two-people-exchanging-saliva', label: 'Two People Exchanging Saliva', filmTitle: 'Two People Exchanging Saliva', trailerUrl: trailer('Two People Exchanging Saliva') },
    ],
  }
];

export const OSCARS_2026_CATEGORY_COUNT = OSCARS_2026_CATEGORIES.length;
